"use client";

import { c as _c } from "react/compiler-runtime";
import { classNames, FlexCenter, FlexColumn, SkeletonLine, TextLabel, TextLabelSkeleton } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { ItemAttributesGridSkeleton } from "./ItemAttributesGridSkeleton";
import { ItemAttributesTableSkeleton } from "./ItemAttributesTableSkeleton";
import { useAttributeView } from "./ItemAttributesViewProvider";
export function ItemAttributesSkeleton(t0) {
  const $ = _c(27);
  const {
    className,
    overrides
  } = t0;
  const {
    attributeView
  } = useAttributeView();
  const t = useTranslations("ItemAttributes");
  let t1;
  if ($[0] !== className) {
    t1 = classNames("gap-4", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("traits");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <TextLabel size="sm">{t2}</TextLabel>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = overrides?.Skeleton?.className;
  let t5;
  if ($[6] !== t4) {
    t5 = classNames("w-[25px]", t4);
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <TextLabelSkeleton className={t5} size="sm" />;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t6) {
    t7 = <FlexCenter className="gap-3">{t3}{t6}</FlexCenter>;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = overrides?.Skeleton?.className;
  let t9;
  if ($[13] !== t8) {
    t9 = classNames("size-8", t8);
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t9) {
    t10 = <SkeletonLine className={t9} />;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t7) {
    t11 = <FlexCenter className="justify-between">{t7}{t10}</FlexCenter>;
    $[17] = t10;
    $[18] = t7;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== attributeView || $[21] !== overrides) {
    t12 = attributeView === "grid" ? <ItemAttributesGridSkeleton overrides={overrides} /> : <ItemAttributesTableSkeleton overrides={overrides} />;
    $[20] = attributeView;
    $[21] = overrides;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t1 || $[24] !== t11 || $[25] !== t12) {
    t13 = <FlexColumn className={t1}>{t11}{t12}</FlexColumn>;
    $[23] = t1;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
}